import { DataVolume, Entity, FieldType, isUuid, PersistenceType } from 'gossamer-unified';

export interface UserRow {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  userType: string;
}

export const User: Entity<UserRow> = {
  id: 'User',
  title: 'User',
  service: 'main',
  rowLabel: (row: UserRow) => `${row.firstName} ${row.lastName}`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.user',
  },
  security: [{ role: 'admin', action: 'all', access: 'all' }],
  defaultSort: [['lastName', 'DESC']],
  defaultFilters: [{ fieldId: 'lastName', operator: 'ct', value: '' }],
  listRowLink: '/user/display/{key}',
  skipReferenceLookup: (key: string) => !isUuid(key),
  dataVolume: DataVolume.Medium,
  fields: {
    id: {
      seq: 5,
      type: FieldType.Text,
      label: 'Id',
      persistence: PersistenceType.SetOnCreateOnly,
      mandatory: true,
      listColumn: true,
      maxLength: 40,
    },
    firstName: {
      seq: 10,
      type: FieldType.Text,
      label: 'First Name',
      mandatory: true,
      listColumn: true,
      maxLength: 80,
    },
    lastName: {
      seq: 15,
      type: FieldType.Text,
      label: 'Last Name',
      mandatory: true,
      listColumn: true,
      maxLength: 80,
    },
    email: {
      seq: 20,
      type: FieldType.Text,
      label: 'Email',
      mandatory: true,
      listColumn: true,
      maxLength: 80,
    },
    userType: {
      seq: 25,
      type: FieldType.Text,
      label: 'Type',
      listColumn: true,
    },
  },
};
